import { faTimes } from "@fortawesome/pro-regular-svg-icons/faTimes";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconClose: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faTimes} />;
};
